import React from 'react'
import { Route } from 'react-router-dom'
import FAQsAuth from './FAQsAuth'

import { faqsAuthRoot } from "../../../constants/routePaths"

const FAQsAuthRoute = [
  <Route
    key="FQAsAuth"
    exact path={faqsAuthRoot}
    component={FAQsAuth}
  />,
];

export default FAQsAuthRoute